import { useEffect } from 'react';

function upsertMeta(attr, key, content) {
  if (typeof document === 'undefined') return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/**
 * Imposta title + description + Open Graph per la route corrente.
 */
export default function DocumentHead({
  title = 'Mangitalia',
  description = 'Eccellenze alimentari italiane selezionate: dal produttore a casa tua.',
  path = '/',
  image = '/assets/images/logo-mangitalia.png',
}) {
  useEffect(() => {
    const fullTitle = title.includes('Mangitalia') ? title : `${title} · Mangitalia`;
    document.title = fullTitle;

    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:locale', 'it_IT');
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', description);

    const origin = typeof window !== 'undefined' ? window.location.origin : 'https://www.mangitalia.online';
    const url = `${origin}${path.startsWith('/') ? path : `/${path}`}`;
    upsertMeta('property', 'og:url', url);

    const absImage = image.startsWith('http') ? image : `${origin}${image}`;
    upsertMeta('property', 'og:image', absImage);
    upsertMeta('name', 'twitter:image', absImage);
  }, [title, description, path, image]);

  return null;
}
